const EMAIL_REG_EXP = new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)

export const isMailValid = (mail: string) => EMAIL_REG_EXP.test(mail)
